import { isEmbarcacaoEquipamentosEmpty } from "@/modules/embarcacoes/embarcacoes.types";
import type {
  EmbarcacaoEquipamentos,
  EmbarcacaoEquipamentosState,
} from "@/modules/embarcacoes/embarcacoes.types";
import {
  useEmbarcacaoDetailSection,
  type EmbarcacaoDetailSectionQuery,
} from "./use-embarcacao-detail-section";

const EQUIPAMENTOS_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoEquipamentos> = {
  select: (ficha) => ficha.equipamentos,
  isEmpty: isEmbarcacaoEquipamentosEmpty,
  secao: "os Equipamentos",
};

interface UseEmbarcacaoEquipamentosResult extends EmbarcacaoEquipamentosState {
  reload: () => void;
}

/** Consulta os Equipamentos (Fi-Fi e Watermaker) da embarcação pedida. Somente leitura. */
export function useEmbarcacaoEquipamentos(id: string): UseEmbarcacaoEquipamentosResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, EQUIPAMENTOS_QUERY);

  return { ...state, equipamentos: data };
}
